import { Checkbox, Stack, Typography } from "@mui/material";
import i18n from "../i18n-config";
import CustomAvatar from "./CustomAvatar";

interface Props {
  checked: boolean;
  title: string;
}

export default function CustomUserSelect({
  checked,
  title = i18n.t("quit_page"),
}: Props) {
  return (
  <Stack direction={"row"} alignItems="center" sx={{width: 250}} mb={2}>
    <Checkbox />
    <CustomAvatar avatarStyle={{borderRadius: 100}} />
    <Typography ml={2} fontSize={12} color="#3D423F">{title}</Typography>
  </Stack>
  );
}
